module.exports = __webpack_public_path__ + "img/banner_naj_projekt.5c4720e0.jpg";